import React from 'react';

const Button = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  className = '',
  disabled = false,
  loading = false,
  fullWidth = false,
  type = 'button',
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center rounded-md font-medium ' +
    'transition-colors active:scale-[0.98] focus-visible:outline-none ' +
    'focus-visible:ring-2 focus-visible:ring-offset-2 ' +
    'disabled:cursor-not-allowed disabled:active:scale-100 disabled:opacity-50 disabled:pointer-events-none';

  const variantClasses = {
    primary:   'bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-700 focus-visible:ring-primary-500',
    secondary: 'bg-primary-50 text-primary-700 hover:bg-primary-100 active:bg-primary-200 focus-visible:ring-primary-500',
    outline:   'border border-primary-500 bg-white text-primary-500 hover:bg-primary-50 hover:text-primary-600 active:bg-primary-100 focus-visible:ring-primary-500',
    ghost:     'bg-transparent text-ink-body hover:bg-ink-canvas hover:text-ink focus-visible:ring-primary-500',
    danger:    'bg-danger-500 text-white hover:bg-danger-600 active:bg-danger-700 focus-visible:ring-danger-500',
    dangerOutline: 'border border-danger-500 bg-white text-danger-500 hover:bg-danger-50 active:bg-danger-100 focus-visible:ring-danger-500',
    dangerGhost: 'bg-transparent text-danger-500 hover:bg-danger-50 hover:text-danger-700 active:bg-danger-100 focus-visible:ring-danger-500',
    success:   'bg-success-500 text-white hover:bg-success-600 active:bg-success-700 focus-visible:ring-success-500',
    warning:   'bg-warning-400 text-warning-900 hover:bg-warning-500 active:bg-warning-600 focus-visible:ring-warning-400',
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };

  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${fullWidth ? 'w-full' : ''} ${className}`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={combinedClasses}
      {...props}
    >
      {loading && (
        <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25" />
          <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="4" className="opacity-75" />
        </svg>
      )}
      {!loading && Icon && iconPosition === 'left' && (
        <Icon className={`h-4 w-4 ${children ? 'mr-2' : ''}`} />
      )}
      {children}
      {!loading && Icon && iconPosition === 'right' && (
        <Icon className={`h-4 w-4 ${children ? 'ml-2' : ''}`} />
      )}
    </button>
  );
};

export default Button;